<template>
  <available-components-for-theme0 :specific-components="components" />
</template>
<script lang="ts">
import AvailableComponentsForTheme0 from '~/components/theme0/AvailableComponentsForTheme0.vue';
import { ViewsMixin } from '~/mixins/views.mixin';

export default defineNuxtComponent({
  name: 'Theme0View',

  mixins: [ViewsMixin],

  components: {
    AvailableComponentsForTheme0,
  },

  description:
    'Components that can be used through this theme should be imported here in order to use them dynamically',
});
</script>
